import React from 'react';

interface BackArrowIconProps extends React.SVGProps<SVGSVGElement> {}

const BackArrowIcon: React.FC<BackArrowIconProps> = (props) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_1380_75)">
                <path
                    d="M7.12207 0.318115C7.40647 0.0174239 7.88063 0.0037199 8.18164 0.287842L15.6816 7.37085C15.8316 7.51249 15.917 7.7105 15.917 7.91675C15.917 7.93045 15.9148 7.94416 15.9141 7.95776C15.9148 7.97169 15.917 7.98564 15.917 7.99976C15.917 8.32174 15.7127 8.59363 15.4277 8.69995L8.18164 15.5447C7.88053 15.8291 7.40649 15.8155 7.12207 15.5144C6.83766 15.2133 6.85121 14.7392 7.15234 14.4548L13.1934 8.74976H1C0.585937 8.74958 0.25 8.41386 0.25 7.99976C0.250162 7.58579 0.586036 7.24993 1 7.24976H13.3691L7.15234 1.37866C6.85121 1.09425 6.83766 0.619254 7.12207 0.318115Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_1380_75">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default BackArrowIcon;
